import { Component } from 'react';

import RoomCardTimer from './room_card_timer';

import { getGameByName } from '../../../modules/game';

import RoomCardTooltip from './room_card_tooltip';

import { Redirect, withRouter } from 'react-router-dom';

class RoomCard extends Component {
  constructor(props) {
    super(props);
    this.gameStates = {
      IDLE: -1,
      WAITING: 1,
      IN_GAME: 2,
      STARTING_SOON: 3,
    };

    this.state = {
      game_info: -1,
      show_tooltip: false,
      room_code: null,
    };
    this.gameImages = null;
  }

  showTooltip() {
    this.setState({ show_tooltip: true });
  }

  hideTooltip() {
    this.setState({ show_tooltip: false });
  }

  async componentDidMount() {
    const { room_data } = this.props;
    const gameDataResponse = await getGameByName(room_data.game_name);

    if (gameDataResponse && gameDataResponse.data.success) {
      this.setState({ game_info: gameDataResponse.data.game });
    }
  }

  onJoinClick() {
    const { room_data } = this.props;
    this.setState({ ...this.state, room_code: room_data.key });
  }

  render() {
    const { room_data, location } = this.props;

    const { game_info, show_tooltip, room_code } = this.state;
    if (room_code) {
      return <Redirect push to={{ pathname: `/play/multiplayer/${room_code}`, state: { from: location.pathname } }} />;
    }
    const info = room_data.info;
    const name = `Join a live ${room_data.game_name} game`;
    const description = `Public ${room_data.game_name} games are always on.`;
    const gameName = room_data.game_name;
    const playerCount = info.player_count;
    const roomStatus = info.status;
    let allowJoin = false;

    switch (parseInt(roomStatus, 10)) {
      case this.gameStates.WAITING:
        allowJoin = true;
        break;
      case this.gameStates.STARTING_SOON:
        allowJoin = true;
        break;
      default:
        break;
    }
    if (room_data.is_full) {
      allowJoin = false;
    }
    let playersText = 'players';

    if (playerCount === 1) {
      playersText = 'player';
    }

    const roomImage = new URL(`../../../static/assets/multiplayer_card_images/${gameName}.png`, import.meta.url).href;

    return (
      <div
        className="multiplayer_card_container"
        onMouseEnter={this.showTooltip.bind(this)}
        onMouseLeave={this.hideTooltip.bind(this)}
      >
        <div className="online_room_card">
          <img alt="background_image_multi" className="multiplayer_card_background_image" src={roomImage} />
          {show_tooltip && <RoomCardTooltip game_info={game_info}></RoomCardTooltip>}
          <div className="room_card_top_label">
            <span className="live_dot"></span>
            <span className="live_text">Live</span>
            <span className="room_card_label">Starting in:</span>
            <RoomCardTimer timer={room_data.timer} />
          </div>
          {playerCount > 0 && (
            <div className="online_room_card_player_count">
              {playerCount} {playersText} in the room
            </div>
          )}
          {allowJoin && (
            <div className="online_room_join" onClick={this.onJoinClick.bind(this)}>
              JOIN GAME
            </div>
          )}
        </div>
        <div className="room_card_text">
          <div className="room_card_text_title">
            <i className="fa fa-group multiplayer_sub_icon"></i>
            {name}
          </div>
          <div className="room_card_text_description">{description}</div>
        </div>
      </div>
    );
  }
}

export default withRouter(RoomCard);
